/*
 *  PostEditor__Indeed.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React from "react";
import styled from "styled-components";
//------------------------------------------------------------------------------
// Internal dep.
//------------------------------------------------------------------------------
import ChannelDataEditor from "../Campaign__Create_ChannelDataEditor.jsx";
import HTMLEditor from "../Campaign__Create_HTMLEditor.jsx";
import ChannelDataSelectList from "../Campaign__Create_ChannelDataSelectList.jsx";
import { indeedBundeslands } from "../constants";
import { channelsByShortName } from "../../../../data/app__channels";
import { useTranslation } from "react-i18next";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const PostEditorIndeedWrapper = styled.div`
  width: 580px;
  background-color: #fff;
  box-shadow: 0px 2px 4px 0px #1516331f;
  border-radius: 4px;
`;
const HeaderWrapper = styled.div`
  position: relative;
  padding: 15px;
  text-align: left;
`;
const TitleWrapper = styled.div`
  display: flex;
  margin-left: -6px;
`;
const ApplyButton = styled.a`
  background: blue;
  color: white !important;
  display: block;
  text-decoration: none;
  color: white;
  width: 200px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 30px;
  margin-top: -6px;
`;
const CompanyWrapper = styled.div`
  display: flex;
  font-size: 15px;
  margin: ${(props) => (props.editable ? "0px 0 15px -6px" : "10px 0 10px -6px")};
  align-items: center;
`;
const Underline = styled.div`
  width: 50%;
  height: 1px;
  background-color: rgba(191, 191, 191, 0.3);
  margin: 10px;
`;
const StateSelectorWrapper = styled.div`
  min-width: 180px;
  margin-left: 5px;
`;

const JobTypeSelectorWrapper = styled.div`
  min-width: 100px;
  margin-left: 5px;
`;

const titleStyle = {
  fontWeight: 500,
  fontSize: "22px",
  fontFamily: "Inter, sans-serif",
  lineHeight: "1.2em"
};
const companyNameStyle = {
  fontWeight: 500,
  fontSize: "14px",
  fontFamily: "Inter, sans-serif"
};
const pageNameStyle = {
  fontWeight: 300,
  fontSize: "14px",
  fontFamily: "Inter, sans-serif"
};

//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const PostEditorIndeed = ({
  postData,
  channelData,
  updatePost,
  updateChannelData,
  editable,
  campaignLanguage
}) => {
  const { t } = useTranslation();
  return (
    <PostEditorIndeedWrapper>
      <HeaderWrapper>
        <TitleWrapper>
          <ChannelDataEditor
            tooltip={t("Job Title")}
            updateChannelData={updateChannelData}
            value={channelData.title}
            dataKey="title"
            textStyle={titleStyle}
            limit={channelsByShortName.indeed.limits.title}
            label={t("Job Title")}
            editable={editable}
          />
        </TitleWrapper>
        <CompanyWrapper editable={editable}>
          <ChannelDataEditor
            tooltip="FIRMENNAME"
            updateChannelData={updateChannelData}
            value={channelData.companyName}
            dataKey="companyName"
            textStyle={companyNameStyle}
            limit={channelsByShortName.indeed.limits.companyName}
            label="FIRMENNAME"
            editable={editable}
          />
          ·
          <ChannelDataEditor
            tooltip="STANDORT"
            updateChannelData={updateChannelData}
            value={channelData.pageName}
            dataKey="pageName"
            textStyle={pageNameStyle}
            limit={channelsByShortName.indeed.limits.pageName}
            label="STANDORT"
            editable={editable}
          />
          <StateSelectorWrapper>
            <ChannelDataSelectList
              label="BUNDESLANDS"
              options={indeedBundeslands}
              value={channelData.state}
              dataKey="state"
              updateChannelData={updateChannelData}
              editable={editable}
              showLabel={false}
            />
          </StateSelectorWrapper>
          <JobTypeSelectorWrapper>
            <ChannelDataSelectList
              label="CONTRACT TYPE"
              options={["fulltime", "parttime"]}
              value={channelData.jobType || "fulltime"}
              dataKey="jobType"
              updateChannelData={updateChannelData}
              editable={editable}
              showLabel={false}
            />
          </JobTypeSelectorWrapper>
        </CompanyWrapper>
        <ApplyButton target="_blank" href={channelData?.url || "#"}>
          {t("Continue to application", { lng: campaignLanguage })}
        </ApplyButton>
        <Underline />
      </HeaderWrapper>
      <HTMLEditor html={postData.jobPostingMarkup} updatePost={updatePost} editable={editable} />
    </PostEditorIndeedWrapper>
  );
};

export default PostEditorIndeed;
